import './search-header.scss';

import { Component } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { OptionsToolbar } from '../options-toolbar';
import { QueryInput } from '../query-input';

export interface SearchParams {
    nbResults: number,
    queryText: string;
    sortType: string;
    sortAsc: boolean;
    startAt?: number;
}

@Component({
    components: {
        sOptionsToolbar: OptionsToolbar,
        sQueryInput: QueryInput,
    },
    props: ['title', 'barcodeEnabled', 'sortingEntityFields'],
    template: require('./search-header.html'),
})
export class SearchHeader extends ReactiveVue {

    public title;
    public barcodeEnabled: boolean;
    public totalResults: number = null as any;
    public sortingEntityFields: any[];

    public searchParams: SearchParams = {
        nbResults: 15,
        queryText: '',
        sortAsc: true,
        sortType: '',
    };

    public mounted() {
        this.subscribeToBus('nb-results-changed', (message) => {
            this.totalResults = message.payload.totalResults
        })
    }

    public onInputChange(value) {
        this.searchParams.queryText = value;
    }

    public onOptionsChange(options: Partial<SearchParams>) {
        this.searchParams = {
            ...this.searchParams,
            ...options,
        };
    }
}
